import { getClient } from '@epilot/migrations-client'
import { useMemo } from 'react'

import { config } from '../configs/api.config'

import { configureClient } from './api-utils'

let client: ReturnType<typeof getClient>

export const getMigrationClient = () => {
  if (!client) {
    client = getClient()

    configureClient(client, {
      baseURL: config.MIGRATIONS
    })
  }

  return client
}

export const useMigrationClient = () => useMemo(() => getMigrationClient(), [])
